module.exports = __webpack_public_path__ + "static/media/logo_CCA_azul_chapado.6f02dcc5.png";